<template>
  <div>
    <b-row>
      <b-col>
        <ulu-parking-row
          :title="$t('globals.no_parkings')"
          :loading="loading"
          :int_value="no_parkings"
        />
        <ulu-parking-row
          :title="$t('globals.parkings_value')"
          :loading="loading"
          :price_value="total_parking_costs_no_fees"
        />
        <ulu-parking-row
          :title="$t('globals.no_fees')"
          :loading="loading"
          :int_value="no_fees"
        />
        <ulu-parking-row
          :title="$t('globals.fees_value')"
          :loading="loading"
          :price_value="total_fees_value"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <ulu-date-picker
          range
          type="month"
          v-model="range"
          lang="en"
          format="DD.MM.YYYY"
          :placeholder="$t('globals.select_range')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";

export default {
  components: {
    "ulu-parking-row": () =>
      import("@/components/dashboard/parkings/ParkingRow.vue"),
    "ulu-date-picker": DatePicker
  },
  data() {
    return {
      range: null,
      tabIndex: 2,
      no_parkings: 0,
      total_parking_costs_no_fees: 0,
      no_fees: 0,
      total_fees_value: 0,
      loading: false
    };
  },
  methods: {
    ...mapActions("stats", ["fetchParkingStatsForRange"]),
    fetchParkingsStats(range) {
      this.loading = true;

      this.fetchParkingStatsForRange({ range: range })
        .then(res => {
          this.no_parkings = res.parkingStatsForPeriod[0];
          this.total_parking_costs_no_fees = res.parkingStatsForPeriod[1];
          this.no_fees = res.parkingStatsForPeriod[2];
          this.total_fees_value = res.parkingStatsForPeriod[3];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchData(range) {
      this.fetchParkingsStats(range);
    },
    clean() {
      this.range = null;
      this.no_parkings = 0;
      this.total_parking_costs_no_fees = 0;
      this.no_fees = 0;
      this.total_fees_value = 0;
    }
  },
  computed: {
    ...mapGetters(["getUserSystem", "getDefConf", "getGraphQlUrl"]),
    isLoading() {
      return this.loading;
    }
  },
  watch: {
    range: function(newRange) {
      if (newRange && newRange[0] !== null && newRange[1] !== null) {
        let from = new Date(newRange[0]);
        let to = new Date(newRange[1]);

        from.setHours(from.getHours() + 1);
        to.setHours(to.getHours() + 25);

        let fetch_range = [
          `${from.getFullYear()}-${from.getMonth()+1}-${from.getDate()}`,
          `${to.getFullYear()}-${to.getMonth()+1}-${to.getDate()}`
        ];

        this.fetchData(fetch_range);
      } else {
        this.clean();
      }
    }
  },
  mounted() {
    //this.fetchData();
  }
};
</script>
